import type { KatDropdownButton } from "@amzn/katal-react";
import client from "src/api/client";
import { isStandalone } from "src/api/config";

export interface KatalDropdownButtonOption {
  readonly label: string;
  readonly action: string;
}

export const downloadAction = (
  testId: string,
  setDownloadingState: (state: boolean) => void
) => {
  return async (event: KatDropdownButton.ActionEvent) => {
    setDownloadingState(true);
    event.preventDefault();
    const {
      detail: { action },
    } = event;

    try {
      const presignedURL = await client.getInputFilePresignedURL({
        testRunId: testId,
        file: action,
      });
      window.open(presignedURL.presignedURL, "_blank");
    } finally {
      setDownloadingState(false);
    }
  };
};

export const getDownloadOptions = (
  t: (key: string) => string
): KatalDropdownButtonOption[] => {
  const downloadOptions = [
    { label: t("aic_nest_download_input_file"), action: "INPUT" },
  ];

  if (isStandalone()) {
    downloadOptions.push(
      { label: "CDM", action: "CONVERTED" },
      { label: "CDM Conversion Log", action: "AUDIT_LOG" },
      { label: "Embedded File", action: "EMBEDDED" }
    );
  }

  return downloadOptions;
};
